// Typing presence helpers (5s stale, label copy).

export const TYPING_STALE_MS = 5_000;
export const STOP_TYPING_IDLE_MS = 4_000;

export interface TypingPeer {
  readonly deviceKey: string;
  readonly displayName: string;
  readonly lastActiveMs: number;
}

/** Drop typers idle longer than `TYPING_STALE_MS`. */
export function pruneTypingPeers(
  peers: Map<string, TypingPeer>,
  nowMs: number = Date.now(),
): Map<string, TypingPeer> {
  const cutoff = nowMs - TYPING_STALE_MS;
  const next = new Map<string, TypingPeer>();
  for (const [key, peer] of peers) {
    if (peer.lastActiveMs > cutoff) {
      next.set(key, peer);
    }
  }
  return next;
}

/** Header / indicator copy for active typers. */
export function formatTypingSubtitle(peers: ReadonlyArray<TypingPeer>): string | null {
  if (peers.length === 0) return null;
  const sorted = [...peers].sort((a, b) => a.displayName.localeCompare(b.displayName));
  if (sorted.length === 1) {
    return `${sorted[0]!.displayName} is typing…`;
  }
  if (sorted.length === 2) {
    return `${sorted[0]!.displayName} & ${sorted[1]!.displayName} are typing…`;
  }
  return `${sorted.length} people are typing…`;
}

export function deviceKeyFromBytes(device: Uint8Array): string {
  return Array.from(device, (b) => b.toString(16).padStart(2, '0')).join('');
}
